<!--
 * @Descripttion: 门户首页
 * @Author: chenjinsheng
 * @Date: 2021-08-05 09:21:25
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-10-20 09:11:32
-->
<template>
    <div class="dwwb-home--page">
        <message-news />
        <div class="content-container">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
                    <batch-approval />
                </el-col>
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                    <my-schedule />
                </el-col>
            </el-row>
            <app-tabs />
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
                    <estate-document />
                </el-col>
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                    <estate-institution />
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import MessageNews from "./message-news";
import BatchApproval from "./batch-approval";
import MySchedule from "./my-schedule";
import AppTabs from "./app-tabs";
import EstateDocument from "./estate-document";
import EstateInstitution from "./estate-institution";

export default {
    name: "Home",
    components: {
        MessageNews,
        BatchApproval,
        MySchedule,
        AppTabs,
        EstateDocument,
        EstateInstitution,
    },

    data() {
        return {
            show: false,
        };
    },
};
</script>

<style lang="scss" scoped>
.dwwb-home--page {
    position: relative;
    width: 100%;
    .content-container {
        // width: calc(100% - 172px);
        // margin: 0 86px;
        // width: 86%;
        margin: 0 7%;
        .widget-item {
            width: 100%;
            display: flex;
            overflow: hidden;
            flex-wrap: wrap;
        }
    }
}
</style>
